import { GeoJsonProperties } from 'geojson';
import { ReactNode } from 'react';
import { Popup as LeafletPopup } from 'react-leaflet';

export const Popup = ({
  featureProperties,
  popupFunction,
}: {
  featureProperties: GeoJsonProperties;
  popupFunction?: (...args: any[]) => ReactNode;
}) => {
  if (!popupFunction) {
    return null;
  }

  return <LeafletPopup>{popupFunction(featureProperties)}</LeafletPopup>;
};
